import React, { useState } from 'react';
import { Alert, Button, Dialog, DialogActions, DialogContent, DialogTitle, IconButton, Tooltip, Typography } from '@mui/material';
import { DeleteOutline } from '@mui/icons-material';
import { documentService } from '../services/documentService';

const DeleteDocumentButton: React.FC<{ documentId: string; title: string; onDeleted: () => void }> = ({ documentId, title, onDeleted }) => {
  const [open, setOpen] = useState(false);
  const [deleting, setDeleting] = useState(false);
  const [error, setError] = useState('');

  const handleDelete = async () => {
    setDeleting(true);
    setError('');
    try {
      await documentService.deleteDocument(documentId);
      setOpen(false);
      onDeleted();
    } catch {
      setError('Unable to delete this document. Please try again.');
    } finally {
      setDeleting(false);
    }
  };

  return <>
    <Tooltip title="Delete Document">
      <IconButton size="small" color="error" aria-label="Delete Document" onClick={() => { setError(''); setOpen(true); }}>
        <DeleteOutline fontSize="small" />
      </IconButton>
    </Tooltip>
    <Dialog open={open} onClose={() => !deleting && setOpen(false)} aria-labelledby={`delete-document-${documentId}`}>
      <DialogTitle id={`delete-document-${documentId}`}>Delete document?</DialogTitle>
      <DialogContent>
        <Typography>Delete “{title}”? It will be removed from your library and from the lawyer and executor profiles. Existing document links will stop working.</Typography>
        {error && <Alert severity="error" sx={{ mt: 2 }}>{error}</Alert>}
      </DialogContent>
      <DialogActions>
        <Button disabled={deleting} onClick={() => setOpen(false)}>Cancel</Button>
        <Button color="error" variant="contained" disabled={deleting} onClick={handleDelete}>
          {deleting ? 'Deleting…' : 'Delete'}
        </Button>
      </DialogActions>
    </Dialog>
  </>;
};

export default DeleteDocumentButton;
